var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddKpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 6.0415C10.3465 6.0415 10.6263 6.32133 10.6263 6.6665V9.37484H13.3346C13.6798 9.37484 13.9596 9.65466 13.9596 9.99984C13.9596 10.345 13.6798 10.6248 13.3346 10.6248H10.6263V13.3332C10.6263 13.6783 10.3465 13.9582 10.0013 13.9582C9.65612 13.9582 9.3763 13.6783 9.3763 13.3332V10.6248H6.66797C6.32279 10.6248 6.04297 10.345 6.04297 9.99984C6.04297 9.65466 6.32279 9.37484 6.66797 9.37484H9.3763V6.6665C9.3763 6.32133 9.65612 6.0415 10.0013 6.0415Z",
    fill: "#9897A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 2.2915C5.74411 2.2915 2.29297 5.74264 2.29297 9.99984C2.29297 14.257 5.74411 17.7082 10.0013 17.7082C14.2585 17.7082 17.7096 14.257 17.7096 9.99984C17.7096 5.74264 14.2585 2.2915 10.0013 2.2915ZM1.04297 9.99984C1.04297 5.05229 5.05375 1.0415 10.0013 1.0415C14.9489 1.0415 18.9596 5.05229 18.9596 9.99984C18.9596 14.9474 14.9489 18.9582 10.0013 18.9582C5.05375 18.9582 1.04297 14.9474 1.04297 9.99984Z",
    fill: "#9897A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddKpi);
export default __webpack_public_path__ + "static/media/iconAddKPI.2992e8f380938838946648489e0ee519.svg";
export { ForwardRef as ReactComponent };